/* added quick-view modal center */
!(function (e) {
    var t = {
        ellaTimeout: null,
        isSidebarAjaxClick: !1,
        init: function () {
            console.log('js init start');
            this.initColorSwatchGrid(),
                this.initResizeImage(),
                this.initMobileMenu(),
                this.initSidebar(),
                this.initMobileSidebar(),
                this.initScrollTop(),
                this.initQuickView(),
                this.initCloudzoom(),
                this.initProductMoreview(),
                this.initAddToCart(),
                this.initModal(),
                this.initModalView(),
                //this.initModalViewBundle(),
                this.initModalViewCenter(),
                this.initResizeModalView(),
                this.initProductAddToCart(),
                this.initDropDownCart(),
                this.initDropdownSearch(),
                this.initToggleCollectionPanel(),
                this.initWishlist(),
                this.initProductWishlist(),
                this.initRemoveWishlist(),
                this.initSwatches(),
                this.initInfiniteScrolling();
        },
        sidebarMapTagEvents: function () {
            e('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function (i) {
                var a = [];
                if (
                    (Shopify.queryParams.constraint && (a = Shopify.queryParams.constraint.split("+")),
                    !window.enable_sidebar_multiple_choice && !e(this).prev().is(":checked"))
                ) {
                    var o,
                        n,
                        r = e(this).parents(".sidebar-tag").find("input:checked");
                    r.length > 0 && (o = r.val()) && (n = a.indexOf(o)) >= 0 && a.splice(n, 1);
                }
                (o = e(this).prev().val()) && ((n = a.indexOf(o)) >= 0 ? a.splice(n, 1) : a.push(o)),
                    a.length ? (Shopify.queryParams.constraint = a.join("+")) : delete Shopify.queryParams.constraint,
                    t.sidebarAjaxClick(),
                    i.preventDefault();
            });
        },
        sidebarMapCategories: function () {
            e(".sidebar-links a").click(function (i) {
                e(this).hasClass("active") ||
                    (delete Shopify.queryParams.q,
                    t.sidebarAjaxClick(e(this).attr("href")),
                    e(".sidebar-links a.active").removeClass("active"),
                    e(this).addClass("active")),
                    i.preventDefault();
            });
        },
        sidebarMapView: function () {
            e(".view-mode a").click(function (i) {
                if (!e(this).hasClass("active")) {
                    var a = e(".filter-show > button span").text();
                    e(this).hasClass("list") ? (Shopify.queryParams.view = "list" + a) : (Shopify.queryParams.view = a),
                        t.sidebarAjaxClick(),
                        e(".view-mode a.active").removeClass("active"),
                        e(this).addClass("active");
                }
                i.preventDefault();
            });
        },
        sidebarMapShow: function () {
            e(".filter-show a").click(function (i) {
                if (!e(this).parent().hasClass("active")) {
                    var a = e(this).attr("href"),
                        o = e(".view-mode a.active").attr("href");
                    (Shopify.queryParams.view = "list" == o ? "list" + a : a),
                        t.sidebarAjaxClick(),
                        e(".filter-show > button span").text(a),
                        e(".filter-show li.active").removeClass("active"),
                        e(this).parent().addClass("active");
                }
                i.preventDefault();
            });
        },
        sidebarInitToggle: function () {
            e(".sidebar-tag").length > 0 &&
                e(".sidebar-tag .widget-title span").click(function () {
                    var i = e(this).parents(".widget-title");
                    i.hasClass("click") ? i.removeClass("click") : i.addClass("click"),
                        e(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
        },
        sidebarMapSorting: function (i) {
            e(".filter-sortby a").click(function (i) {
                if (!e(this).parent().hasClass("active")) {
                    (Shopify.queryParams.sort_by = e(this).attr("href")), t.sidebarAjaxClick();
                    var a = e(this).text();
                    e(".filter-sortby > button span").text(a),
                        e(".filter-sortby li.active").removeClass("active"),
                        e(this).parent().addClass("active");
                }
                i.preventDefault();
            });
        },
        sidebarMapPaging: function () {
            e(".pagination-page a").click(function (i) {
                var a = e(this)
                    .attr("href")
                    .match(/page=\d+/g);
                if (a && ((Shopify.queryParams.page = parseInt(a[0].match(/\d+/g))), Shopify.queryParams.page)) {
                    var o = t.sidebarCreateUrl();
                    (t.isSidebarAjaxClick = !0),
                        History.pushState({ param: Shopify.queryParams }, o, o),
                        t.sidebarGetContent(o),
                        e("body,html").animate({ scrollTop: 500 }, 600);
                }
                i.preventDefault();
            });
        },
        sidebarMapClearAll: function () {
            e(".refined-widgets a.clear-all").click(function (i) {
                delete Shopify.queryParams.constraint,
                    delete Shopify.queryParams.q,
                    t.sidebarAjaxClick(),
                    i.preventDefault();
            });
        },
        sidebarMapClear: function () {
            e(".sidebar-tag").each(function () {
                var i = e(this);
                i.find("input:checked").length > 0 &&
                    i
                        .find(".clear")
                        .show()
                        .click(function (a) {
                            console.log("im clicked");
                            var o = [];
                            Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")),
                                i.find("input:checked").each(function () {
                                    var i = e(this).val();
                                    if (i) {
                                        var t = o.indexOf(i);
                                        t >= 0 && o.splice(t, 1);
                                    }
                                }),
                                o.length
                                    ? (Shopify.queryParams.constraint = o.join("+"))
                                    : delete Shopify.queryParams.constraint,
                                t.sidebarAjaxClick(),
                                a.preventDefault();
                        });
            });
        },
        sidebarMapEvents: function () {
            t.sidebarMapTagEvents(),
                t.sidebarMapCategories(),
                t.sidebarMapView(),
                t.sidebarMapShow(),
                t.sidebarMapSorting();
        },
        reActivateSidebar: function () {
            e(".sidebar-custom .active, .sidebar-links .active").removeClass("active"),
                e(".sidebar-tag input:checked").attr("checked", !1);
            var i = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (
                (i && i[1] && e(".sidebar-links a[href='" + i[0] + "']").addClass("active"), Shopify.queryParams.view)
            ) {
                e(".view-mode .active").removeClass("active");
                var a = Shopify.queryParams.view;
                a.indexOf("list") >= 0
                    ? (e(".view-mode .list").addClass("active"), (a = a.replace("list", "")))
                    : e(".view-mode .grid").addClass("active"),
                    e(".filter-show > button span").text(a),
                    e(".filter-show li.active").removeClass("active"),
                    e(".filter-show a[href='" + a + "']")
                        .parent()
                        .addClass("active");
            }
            t.initSortby();
        },
        initSortby: function () {
            if (Shopify.queryParams.sort_by) {
                var i = Shopify.queryParams.sort_by,
                    t = e(".filter-sortby a[href='" + i + "']").text();
                e(".filter-sortby > button span").text(t),
                    e(".filter-sortby li.active").removeClass("active"),
                    e(".filter-sortby a[href='" + i + "']")
                        .parent()
                        .addClass("active");
            }
        },
        initSwatches: function () {
            e("#product-variants").length && initSwatchSelectors();
        },
        sidebarMapData: function (i) {
            var a = e(".col-main .products-grid");
            0 == a.length && (a = e(".col-main .product-list"));
            var o = e(i).find(".col-main .products-grid");
            0 == o.length && (o = e(i).find(".col-main .product-list")),
                o.length > 0 &&
                    o.hasClass("products-grid") &&
                    window.product_image_resize &&
                    o
                        .find("img")
                        .fakecrop({
                            fill: window.images_size.is_crop,
                            widthSelector: ".products-grid .grid-item .product-image",
                            ratioWrapper: window.images_size,
                        }),
                a.replaceWith(o),
                t.checkNeedToConvertCurrency() &&
                    Currency.convertAll(
                        window.shop_currency,
                        jQuery("#currencies").val(),
                        ".col-main span.money",
                        "money_format"
                    ),
                e(".padding").length > 0
                    ? e(".padding").replaceWith(e(i).find(".padding"))
                    : e(".block-row.col-main").append(e(i).find(".padding"));
            var n = e(".page-header"),
                r = e(i).find(".page-header");
            if (
                (n.find("h2").text() != r.find("h2").text() &&
                    (n.find("h2").replaceWith(r.find("h2")),
                    n.find(".rte").length
                        ? r.find(".rte").length
                            ? n.find(".rte").replaceWith(r.find(".rte"))
                            : n.find(".rte").hide()
                        : r.find(".rte").length && n.find("h2").after(r.find(".rte"))),
                e(".refined-widgets").replaceWith(e(i).find(".refined-widgets")),
                e(".sidebar-block").replaceWith(e(i).find(".sidebar-block")),
                t.initColorSwatchGrid(),
                e(".spr-badge").length > 0)
            )
                return (
                    window.SPR.registerCallbacks(),
                    window.SPR.initRatingHandler(),
                    window.SPR.initDomEls(),
                    window.SPR.loadProducts(),
                    window.SPR.loadBadges()
                );
        },
        sidebarCreateUrl: function (i) {
            var t = e.param(Shopify.queryParams).replace(/%2B/g, "+");
            return i ? ("" != t ? i + "?" + t : i) : location.pathname + "?" + t;
        },
        sidebarAjaxClick: function (i) {
            delete Shopify.queryParams.page;
            var e = t.sidebarCreateUrl(i);
            (t.isSidebarAjaxClick = !0),
                History.pushState({ param: Shopify.queryParams }, e, e),
                t.sidebarGetContent(e);
        },
        sidebarGetContent: function (i) {
            e.ajax({
                type: "get",
                url: i,
                beforeSend: function () {
                    t.showLoading();
                },
                success: function (i) {
                    t.sidebarMapData(i),
                        t.sidebarMapPaging(),
                        t.translateBlock(".main-content"),
                        t.sidebarMapTagEvents(),
                        t.sidebarInitToggle(),
                        t.sidebarMapClear(),
                        t.sidebarMapClearAll(),
                        t.hideLoading(),
                        t.initQuickView(),
                        t.initAddToCart(),
                        t.initWishlist(),
                        t.initInfiniteScrolling();
                },
                error: function (i, a) {
                    t.hideLoading(),
                        e(".loading-modal").hide(),
                        e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                        t.showModal(".ajax-error-modal");
                },
            });
        },
        sidebarParams: function () {
            if (((Shopify.queryParams = {}), location.search.length))
                for (var i, e = 0, t = location.search.substr(1).split("&"); e < t.length; e++)
                    (i = t[e].split("=")).length > 1 &&
                        (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
        },
        initMobileSidebar: function () {
            e("footer").append(
                "<a class='option-sidebar left' id='displayTextLeft' href='javascript:void(0)' title='Show Sidebar'><span>Show Sidebar</span></a>"
            ),
                e("#displayTextLeft").click(function (i) {
                    i.preventDefault(),
                        e(".sidebar").is(":hidden")
                            ? (e(".sidebar").fadeIn(800),
                              e("body,html").animate({ scrollTop: 400 }, 600),
                              e("#displayTextLeft").toggleClass("hidden-arrow-left"),
                              e("#displayTextLeft").attr("title", "hide-sidebar"),
                              e("#displayTextLeft").html("<span>Hide Sidebar</span>"))
                            : (e(".sidebar").fadeOut(800),
                              e("#displayTextLeft").removeClass("hidden-arrow-left"),
                              e("#displayTextLeft").attr("title", "show-sidebar"),
                              e("#displayTextLeft").html("<span>Show Sidebar</span>"));
                });
        },
        initSidebar: function () {
            e(".collection-sidebar").length > 0 &&
                (t.sidebarParams(),
                t.initSortby(),
                t.sidebarMapEvents(),
                t.sidebarMapPaging(),
                t.sidebarInitToggle(),
                t.sidebarMapClear(),
                t.sidebarMapClearAll());
        },
        initMobileMenu: function () {
            e(".menu-block").is(":visible")
                ? (e(".gf-menu-device-container ul.gf-menu li.dropdown").each(function () {
                      0 == e(this).find("> p.toogleClick").length && e(this).prepend('<p class="toogleClick">+</p>');
                  }),
                  0 == e(".menu-block").children().hasClass("gf-menu-device-wrapper") &&
                      e(".menu-block").children().addClass("gf-menu-device-wrapper"),
                  0 == e(".gf-menu-device-container").find("ul.gf-menu").size() &&
                      (e(".gf-menu-device-container").append(e(".nav-bar .container").html()),
                      e(".gf-menu-device-container .site-nav").addClass("gf-menu"),
                      e(".gf-menu-device-container .site-nav").removeClass("nav")),
                  e("p.toogleClick").click(function () {
                      e(this).hasClass("mobile-toggle-open")
                          ? (e(this).next().next().hide(), e(this).removeClass("mobile-toggle-open"))
                          : (e(this).next().next().show(), e(this).addClass("mobile-toggle-open"));
                  }),
                  e("p.toogleClick").show(),
                  e("div.gf-menu-toggle").hide(),
                  e(".nav-bar .container").hide(),
                  0 == e("ul.gf-menu").hasClass("clicked") &&
                      (e(".gf-menu").hide(), e(".gf-menu li.dropdown ul.site-nav-dropdown").hide()),
                  e(".col-1 .inner ul.dropdown")
                      .parent()
                      .each(function () {
                          0 == e(this).find("> p.toogleClick").length &&
                              e(this).prepend('<p class="toogleClick">+</p>');
                      }),
                  e(".cbp-spmenu span.icon-dropdown").remove(),
                  e("ul.gf-menu li.dropdown").each(function () {
                      0 == e(this).find("> p.toogleClick").length && e(this).prepend('<p class="toogleClick">+</p>');
                  }),
                  e("p.toogleClick").click(function () {
                      e(this).hasClass("mobile-toggle-open")
                          ? (e(this).next().next().hide(), e(this).removeClass("mobile-toggle-open"))
                          : (e(this).next().next().show(), e(this).addClass("mobile-toggle-open"));
                  }),
                  e(".header-panel-bottom ul.customer-links").prependTo(e(".customer-area .dropdown-menu")))
                : (e(".nav-bar .container").show(),
                  e(".gf-menu").hide(),
                  e(".customer-area ul.customer-links").appendTo(e(".header-panel-bottom")).after(e(".top-header"))),
                0 == e(".menu-block").children().hasClass("gf-menu-device-wrapper") &&
                    e(".menu-block").children().addClass("resized");
        },
        initWishlist: function () {
            e(".grid-item button.wishlist").click(function (i) {
                i.preventDefault();
                var a = e(this).parent(),
                    o = a.parents(".grid-item");
                e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: a.serialize(),
                    beforeSend: function () {
                        t.showLoading();
                    },
                    success: function (i) {
                        t.hideLoading(),
                            a.html(
                                '<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>'
                            );
                        var n = o.find(".product-title").html(),
                            r = o.find("a > img").attr("src");
                        e(".ajax-success-modal").find(".ajax-product-title").html(n),
                            e(".ajax-success-modal").find(".ajax-product-image").attr("src", r),
                            e(".ajax-success-modal").find(".btn-go-to-wishlist").show(),
                            e(".ajax-success-modal").find(".btn-go-to-cart").hide(),
                            t.showModal(".ajax-success-modal");
                    },
                    error: function (i, a) {
                        t.hideLoading(),
                            e(".loading-modal").hide(),
                            e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                            t.showModal(".ajax-error-modal");
                    },
                });
            });
        },
        initProductWishlist: function () {
            e(".product button.wishlist").click(function (i) {
                i.preventDefault();
                var a = e(this).parent();
                a.parents(".grid-item"),
                    e.ajax({
                        type: "POST",
                        url: "/contact",
                        data: a.serialize(),
                        beforeSend: function () {
                            t.showLoading();
                        },
                        success: function (i) {
                            t.hideLoading(),
                                a.html(
                                    '<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>'
                                );
                            var o = e(".product-title h2").html(),
                                n = e("#product-featured-image").attr("src");
                            e(".ajax-success-modal").find(".ajax-product-title").html(o),
                                e(".ajax-success-modal").find(".ajax-product-image").attr("src", n),
                                e(".ajax-success-modal").find(".btn-go-to-wishlist").show(),
                                e(".ajax-success-modal").find(".btn-go-to-cart").hide(),
                                t.showModal(".ajax-success-modal");
                        },
                        error: function (i, a) {
                            t.hideLoading(),
                                e(".loading-modal").hide(),
                                e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                                t.showModal(".ajax-error-modal");
                        },
                    });
            });
        },
        initRemoveWishlist: function () {
            e(".btn-remove-wishlist").click(function (i) {
                var a = e(this).parents("tr"),
                    o = a.find(".tag-id").val(),
                    n = jQuery("#remove-wishlist-form");
                n.find("input[name='contact[tags]']").val("x" + o),
                    e.ajax({
                        type: "POST",
                        url: "/contact",
                        data: n.serialize(),
                        beforeSend: function () {
                            t.showLoading();
                        },
                        success: function (i) {
                            t.hideLoading(), a.fadeOut(1e3);
                        },
                        error: function (i, a) {
                            t.hideLoading(),
                                e(".loading-modal").hide(),
                                e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                                t.showModal(".ajax-error-modal");
                        },
                    });
            });
        },
        initColorSwatchGrid: function () {
            jQuery(".item-swatch li label").hover(function () {
                var i = jQuery(this).parent().find(".hidden a").attr("href");
                return jQuery(this).parents(".grid-item").find(".product-grid-image img").attr({ src: i }), !1;
            });
        },
        initResizeImage: function () {
            window.product_image_resize &&
                e(".products-grid .product-image img").fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size,
                });
        },
        initInfiniteScrolling: function () {
            e(".infinite-scrolling").length > 0 &&
                e(".infinite-scrolling a").click(function (i) {
                    i.preventDefault(), e(this).hasClass("disabled") || t.doInfiniteScrolling();
                });
        },
        doInfiniteScrolling: function () {
            var i = e(".block-row .products-grid");
            if ((i.length || (i = e(".block-row .product-list")), i)) {
                var a = e(".infinite-scrolling a").first();
                e.ajax({
                    type: "GET",
                    url: a.attr("href"),
                    beforeSend: function () {
                        t.showLoading(), e(".loading-modal").show();
                    },
                    success: function (o) {
                        t.hideLoading();
                        var n = e(o).find(".block-row .products-grid");
                        if (
                            (n.length || (n = e(o).find(".block-row .product-list")),
                            n.length &&
                                (n.hasClass("products-grid") &&
                                    window.product_image_resize &&
                                    n
                                        .children()
                                        .find("img")
                                        .fakecrop({
                                            fill: window.images_size.is_crop,
                                            widthSelector: ".products-grid .grid-item .product-image",
                                            ratioWrapper: window.images_size,
                                        }),
                                i.append(n.children()),
                                t.translateBlock("." + i.attr("class")),
                                t.initQuickView(),
                                t.initAddToCart(),
                                t.initWishlist(),
                                e(o).find(".infinite-scrolling").length > 0
                                    ? a.attr("href", e(o).find(".infinite-scrolling a").attr("href"))
                                    : (a.hide(), a.next().show()),
                                window.show_multiple_currencies &&
                                    window.shop_currency != jQuery("#currencies").val() &&
                                    Currency.convertAll(
                                        window.shop_currency,
                                        jQuery("#currencies").val(),
                                        "span.money",
                                        "money_format"
                                    ),
                                t.initColorSwatchGrid(),
                                e(".spr-badge").length > 0))
                        )
                            return (
                                window.SPR.registerCallbacks(),
                                window.SPR.initRatingHandler(),
                                window.SPR.initDomEls(),
                                window.SPR.loadProducts(),
                                window.SPR.loadBadges()
                            );
                    },
                    error: function (i, a) {
                        t.hideLoading(),
                            e(".loading-modal").hide(),
                            e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                            t.showModal(".ajax-error-modal");
                    },
                    dataType: "html",
                });
            }
        },
        closeEmailModalWindow: function () {
            e("#email-modal").length > 0 &&
                e("#email-modal").is(":visible") &&
                e("#email-modal .modal-window").fadeOut(600, function () {
                    e("#email-modal .modal-overlay").fadeOut(600, function () {
                        e("#email-modal").hide(), e.cookie("emailSubcribeModal", "closed", { expires: 1, path: "/" });
                    });
                });
        },
        showModal: function (i) {
            e(i).fadeIn(500),
                (t.ellaTimeout = setTimeout(function () {
                    e(i).fadeOut(500);
                }, 5e3));
        },
        initToggleCollectionPanel: function () {
            e(".collection-sharing-btn").length > 0 &&
                e(".collection-sharing-btn").click(function () {
                    e(".collection-sharing-panel").toggle(),
                        e(".collection-sharing-panel").is(":visible")
                            ? (e(".collection-sharing-btn").addClass("btn-hover"),
                              e(".collection-filter-panel").hide(),
                              e(".collection-filter-btn").removeClass("btn-hover"))
                            : e(".collection-sharing-btn").removeClass("btn-hover");
                }),
                e(".collection-filter-btn").length > 0 &&
                    (e(".collection-filter-btn").click(function () {
                        e(".collection-filter-panel").toggle(),
                            e(".collection-filter-panel").is(":visible")
                                ? (e(".collection-filter-btn").addClass("btn-hover"),
                                  e(".collection-sharing-panel").hide(),
                                  e(".collection-sharing-btn").removeClass("btn-hover"))
                                : e(".collection-filter-btn").removeClass("btn-hover");
                    }),
                    e(".collection-filter-panel select").change(function (i) {
                        window.location = e(this).find("option:selected").val();
                    }));
        },
        checkItemsInDropdownCart: function () {
            e("#dropdown-cart .mini-products-list").children().length > 0
                ? (e("#dropdown-cart .no-items").hide(), e("#dropdown-cart .has-items").show())
                : (e("#dropdown-cart .has-items").hide(), e("#dropdown-cart .no-items").show());
        },
        initModal: function () {
            e(".continue-shopping").click(function () {
                clearTimeout(t.ellaTimeout), e(".ajax-success-modal").fadeOut(500);
            }),
                e(".close-modal, .overlay").click(function () {
                    clearTimeout(t.ellaTimeout), e(".ajax-success-modal").fadeOut(500);
                });
        },
        initModalView: function () {
            console.log('normal modal initiated');
            $("a.ksmodal").click(function () {
                var i = $(this).attr("data-target-id"),
                    e =
                        '<div class="overlay"></div><div class="content clearfix"><div class="content-inner clearfix"><div class="product-img-box- col-xs-12">' +
                        $("#" + i).html() +
                        '</div></div><a href="javascript:void(0)" class="close-window">Close</a></div>';
                return (
                    $(".quick-view").html(e),
                    $("html").addClass("overflow-hidden"),
                    $(".quick-view").fadeIn(500),
                    $(".quick-view").animate({ scrollTop: 0 }, "slow"),
                    !1
                );
            });
        },
        initModalViewBundle: function () {
            console.log('bundle modal initiated');
			// this was implemented due to bundle issue. while open the popup, event triggers not moving into popup.
            $("a.ksmodal-bundle").click(function () {
                console.log('bundle modal click');
                var i = $(this).attr("data-target-id");
                var $t_element	= $("#" + i);
                var $t_html		= '';
                var e =
                    '<div class="overlay"></div><div class="content clearfix"><div class="content-inner clearfix"><div class="ksmodal-content-box col-xs-12">' +
                        $t_html +
					'</div></div><a href="javascript:void(0)" class="close-window">Close</a></div>';

                $(".quick-view").html(e);
                console.log('bundle modal html');
				
				// move the original element into popup and show it
				$t_element.appendTo(".quick-view .ksmodal-content-box").show();
                console.log('bundle modal append');
				
                // and optionally show the popup
                $("html").addClass("overflow-hidden");
                $(".quick-view").fadeIn(500).animate({ scrollTop: 0 }, "slow");
                return false;
            });
        },
        initModalViewBundleBackup: function () {
			// this was implemented due to bundle issue. while open the popup, event triggers not moving into popup.
            $("a.ksmodal-bundle").click(function () {
                var i = $(this).attr("data-target-id");
                var $t_element	= $("#" + i);
                var $t_html		= $("#" + i).html();
                if ($(this).hasClass("btn-bundle")) {var $t_html = '';}
                var e =
                    '<div class="overlay"></div><div class="content clearfix"><div class="content-inner clearfix"><div class="ksmodal-content-box col-xs-12">' +
                        $t_html +
					'</div></div><a href="javascript:void(0)" class="close-window">Close</a></div>';

                $(".quick-view").html(e);
				
                if ($(this).hasClass("btn-bundle")) {
                    // move the original element into popup and show it
                    $t_element.appendTo(".quick-view .ksmodal-content-box").show();
                }
				
                // and optionally show the popup
                $("html").addClass("overflow-hidden");
                $(".quick-view").fadeIn(500).animate({ scrollTop: 0 }, "slow");
                return false;
            });
        },
        initModalViewCenter: function () {
            console.log('js initModalViewCenter start');
            $("a.ksmodal-center").click(function () {
                var i = $(this).attr("data-target-id"),
                    e =
                        '<div class="overlay"></div><div class="content clearfix"><div class="content-inner clearfix"><div class="product-img-box- col-xs-12">' +
                        $("#" + i).html() +
                        '</div></div><a href="javascript:void(0)" class="close-window">Close</a></div>';
                return (
                    $(".quick-view-center").html(e),
                    $("html").addClass("overflow-hidden"),
                    $(".quick-view-center").fadeIn(500),
                    t.initResizeModalView(),
                    $(".quick-view-center").animate({ scrollTop: 0 }, "slow"),
                    !1
                );
            });
        },
        initResizeModalView: function () {
            $(".quick-view-center").removeClass("overflow-center");
            var i = $(".quick-view-center").find(".content"),
                e = $(window).height(),
                t = i.height() + 50,
                a = Math.max(0, (e - t) / 2);
            e - t >= 60
                ? (i.css("margin-top", a), i.css("margin-bottom", a))
                : ($(".quick-view-center").addClass("overflow-center"), i.css("margin", "30px auto")),
                console.log(e),
                console.log(t),
                console.log(a);
        },
        initDropDownCart: function () {
            "click" == window.dropdowncart_type
                ? e("#cartToggle").click(function () {
                      e("#dropdown-cart").addClass("cart-active"),
                          e(".sidebar-cart-bg").addClass("cart-active"),
                          e("body").addClass("cart-active"),
                          e("#dropdown-cart .close-icon").click(function (i) {
                              i.preventDefault(), t.closeDropdownCart();
                          });
                  })
                : "ontouchstart" in document
                  ? e("#cartToggle").click(function () {
                        e("#dropdown-cart").is(":visible")
                            ? e("#dropdown-cart").slideUp("fast")
                            : e("#dropdown-cart").slideDown("fast");
                    })
                  : (e("#cartToggle").hover(function () {
                        e("#dropdown-cart").is(":visible") || e("#dropdown-cart").slideDown("fast");
                    }),
                    e(".wrapper-top-cart").mouseleave(function () {
                        e("#dropdown-cart").slideUp("fast");
                    })),
                t.checkItemsInDropdownCart(),
                e("#dropdown-cart .no-items a").click(function () {
                    t.closeDropdownCart();
                }),
                e("#dropdown-cart .btn-remove").click(function (i) {
                    i.preventDefault();
                    var a = e(this).parents(".item").attr("id");
                    (a = a.match(/\d+/g)),
                        Shopify.removeItem(a, function (i) {
                            t.doUpdateDropdownCart(i);
                        });
                });
        },
        closeDropdownCart: function () {
            e("#dropdown-cart").removeClass("cart-active"),
                e(".sidebar-cart-bg").removeClass("cart-active"),
                e("body").removeClass("cart-active"),
                e("#dropdown-cart .close-icon").click(function (i) {
                    i.preventDefault(), t.closeDropdownCart();
                });
        },
        initDropdownSearch: function () {
            e(".nav-search .icon-search").click(function () {
                e(".header-bottom.on .search-bar").is(":visible")
                    ? e(".header-bottom.on .search-bar").slideUp("fast")
                    : e(".header-bottom.on .search-bar").slideDown("fast");
            });
        },
        closeDropdownSearch: function () {
            e(".header-bottom.on .search-bar").is(":visible") && e(".header-bottom.on .search-bar").slideUp("fast");
        },
        initProductMoreview: function () {
            e(".more-view-wrapper-owlslider").length > 0
                ? this.initOwlMoreview()
                : e(".more-view-wrapper-jcarousel").length > 0 && this.initJcarouselMoreview();
        },
        initOwlMoreview: function () {
            e(".more-view-wrapper-owlslider ul")
                .owlCarousel({
                    navigation: !0,
                    items: 5,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 5],
                    itemsTabletSmall: [540, 5],
                    itemsMobile: [360, 3],
                })
                .css("visibility", "visible");
        },
        initJcarouselMoreview: function () {
            e(".more-view-wrapper-jcarousel ul").jcarousel({ vertical: !0 }).css("visibility", "visible"),
                e(".product-img-box").addClass("has-jcarousel"),
                e(".more-view-wrapper").css("visibility", "visible");
        },
        initCloudzoom: function () {
            e("#product-featured-image").length > 0 &&
                (e(".visible-phone").is(":visible")
                    ? (e("#product-featured-image").elevateZoom({
                          gallery: "more-view-carousel",
                          cursor: "pointer",
                          galleryActiveClass: "active",
                          imageCrossfade: !1,
                          scrollZoom: !1,
                          onImageSwapComplete: function () {
                              e(".zoomWrapper div").hide();
                          },
                          loadingIcon: window.loading_url,
                      }),
                      e("#product-featured-image").bind("click", function (i) {
                          return !1;
                      }))
                    : (e("#product-featured-image").elevateZoom({
                          gallery: "more-view-carousel",
                          cursor: "pointer",
                          galleryActiveClass: "active",
                          imageCrossfade: !0,
                          scrollZoom: !0,
                          onImageSwapComplete: function () {
                              e(".zoomWrapper div").hide();
                          },
                          loadingIcon: window.loading_url,
                      }),
                      e("#product-featured-image").bind("click", function (i) {
                          var t = e("#product-featured-image").data("elevateZoom");
                          return e.fancybox(t.getGalleryList()), !1;
                      })));
        },
        initScrollTop: function () {
            e("#back-top").click(function () {
                return e("body,html").animate({ scrollTop: 0 }, 400), !1;
            });
        },
        initProductAddToCart: function () {},
        initAddToCart: function () {
            e(".add-to-cart-btn").length > 0 &&
                e(".add-to-cart-btn").click(function (i) {
                    if ((i.preventDefault(), "disabled" != e(this).attr("disabled"))) {
                        var a = e(this).parents(".product-item"),
                            o = e(a).attr("id");
                        if (((o = o.match(/\d+/g)), window.ajax_cart)) {
                            var n = e("#product-actions-" + o + " select[name=id]").val();
                            n || (n = e("#product-actions-" + o + " input[name=id]").val());
                            var r = e("#product-actions-" + o + " input[name=quantity]").val();
                            r || (r = 1);
                            var s = e(a).find(".product-title").html(),
                                l = e(a).find(".product-grid-image img").attr("src");
                            t.doAjaxAddToCart(n, r, s, l);
                        } else e("#product-actions-" + o).submit();
                    }
                    return !1;
                });
        },
        showLoading: function () {
            e(".loading-modal").show();
        },
        hideLoading: function () {
            e(".loading-modal").hide();
        },
        doAjaxAddToCart: function (i, a, o, n) {
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + a + "&id=" + i,
                dataType: "json",
                beforeSend: function () {
                    t.showLoading();
                },
                success: function (i) {
                    t.hideLoading(),
                        e(".ajax-success-modal").find(".ajax-product-title").html(t.translateText(o)),
                        e(".ajax-success-modal").find(".ajax-product-image").attr("src", n),
                        e(".ajax-success-modal").find(".btn-go-to-wishlist").hide(),
                        e(".ajax-success-modal").find(".btn-go-to-cart").show(),
                        t.showModal(".ajax-success-modal"),
                        t.updateDropdownCart();
                },
                error: function (i, a) {
                    t.hideLoading(),
                        e(".ajax-error-message").text(e.parseJSON(i.responseText).description),
                        t.showModal(".ajax-error-modal");
                },
            });
        },
        initQuickView: function () {
            e(".quickview-button a").click(function () {
                var i = e(this).attr("id");
                return (
                    Shopify.getProduct(i, function (i) {
                        var a = e("#quickview-template").html();
                        e(".quick-view").html(a);
                        var o = e(".quick-view");
                        if (
                            (o.find(".product-title a").html(t.translateText(i.title)),
                            o.find(".product-title a").attr("href", i.url),
                            o.find(".product-vendor span").length > 0 && o.find(".product-vendor span").text(i.vendor),
                            o.find(".product-type span").length > 0 && o.find(".product-type span").text(i.type),
                            o.find(".product-inventory span").length > 0)
                        ) {
                            var n = i.variants[0],
                                r = o.find(".product-inventory span");
                            n.available
                                ? null != n.inventory_management
                                    ? r.text(n.inventory_quantity + " " + window.inventory_text.in_stock)
                                    : r.text(window.inventory_text.many_in_stock)
                                : r.text(window.inventory_text.out_of_stock);
                        }
                        if (i.description.indexOf("[countdown]") > 0) {
                            var s = i.description.match(/\[countdown\](.*)\[\/countdown\]/);
                            s &&
                                s.length > 0 &&
                                (o.find(".countdown").show(),
                                o.find(".quickview-clock").countdown(s[1], function (i) {
                                    e(this).html(i.strftime("%Dd %H:%M:%S"));
                                }));
                        }
                        if (o.find(".product-description").length > 0) {
                            var l = (l = i.description.replace(/(<([^>]+)>)/gi, "")).replace(
                                /\[countdown\](.*)\[\/countdown\]/g,
                                ""
                            );
                            if (window.multi_lang && l.indexOf("[lang2]") > 0) {
                                var c = l.split("[lang2]");
                                l = null != jQuery.cookie("language") ? c[translator.current_lang - 1] : c[0];
                            }
                            (l = l.split(" ").splice(0, 20).join(" ") + "..."), o.find(".product-description").text(l);
                        } else o.find(".product-description").remove();
                        o.find(".price").html(Shopify.formatMoney(i.price, window.money_format)),
                            o.find(".product-item").attr("id", "product-" + i.id),
                            o.find(".variants").attr("id", "product-actions-" + i.id),
                            o.find(".variants select").attr("id", "product-select-" + i.id),
                            i.compare_at_price > i.price
                                ? (o
                                      .find(".compare-price")
                                      .html(Shopify.formatMoney(i.compare_at_price_max, window.money_format))
                                      .show(),
                                  o.find(".price").addClass("on-sale"))
                                : (o.find(".compare-price").html(""), o.find(".price").removeClass("on-sale")),
                            i.available
                                ? (o.find(".total-price span").html(Shopify.formatMoney(i.price, window.money_format)),
                                  window.use_color_swatch
                                      ? t.createQuickViewVariantsSwatch(i, o)
                                      : t.createQuickViewVariants(i, o))
                                : (o.find("select, input, .total-price, .dec, .inc, .variants label").remove(),
                                  o
                                      .find(".add-to-cart-btn")
                                      .text(window.inventory_text.unavailable)
                                      .addClass("disabled")
                                      .attr("disabled", "disabled")),
                            o.find(".button").on("click", function () {
                                var i = o.find(".quantity").val(),
                                    a = 1;
                                "+" == e(this).text() ? (a = parseInt(i) + 1) : i > 1 && (a = parseInt(i) - 1),
                                    o.find(".quantity").val(a),
                                    o.find(".total-price").length > 0 && t.updatePricingQuickview();
                            }),
                            window.show_multiple_currencies &&
                                Currency.convertAll(
                                    window.shop_currency,
                                    jQuery("#currencies").val(),
                                    "span.money",
                                    "money_format"
                                ),
                            t.loadQuickViewSlider(i, o),
                            t.initQuickviewAddToCart(),
                            t.translateBlock(".quick-view"),
                            e(".quick-view").fadeIn(500),
                            e(".quick-view .total-price").length > 0 &&
                                e(".quick-view input[name=quantity]").on("change", t.updatePricingQuickview);
                    }),
                    !1
                );
            }),
                e(".quick-view .overlay, .close-window").live("click", function () {
                    return t.closeQuickViewPopup(), !1;
                }),
                e(".quick-view-center .overlay, .close-window").live("click", function () {
                    return t.closeQuickViewCenterPopup(), !1;
                });
        },
        updatePricingQuickview: function () {
            var i = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
                t = e(".quick-view .price").text().match(i);
            if ((t || ((i = /([0-9]+[.|,][0-9]+)/g), (t = e(".quick-view .price").text().match(i))), t)) {
                var a = t[0],
                    o = a.replace(/[.|,]/g, "") * parseInt(e(".quick-view input[name=quantity]").val()),
                    n = Shopify.formatMoney(o, window.money_format);
                (i = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g),
                    n.match(i) || (i = /([0-9]+[.|,][0-9]+)/g),
                    (n = n.match(i)[0]);
                var r = new RegExp(a, "g"),
                    s = e(".quick-view .price").html().replace(r, n);
                e(".quick-view .total-price span").html(s);
            }
        },
        initQuickviewAddToCart: function () {
            e(".quick-view .add-to-cart-btn").length > 0 &&
                e(".quick-view .add-to-cart-btn").click(function () {
                    var i = e(".quick-view select[name=id]").val();
                    i || (i = e(".quick-view input[name=id]").val());
                    var a = e(".quick-view input[name=quantity]").val();
                    a || (a = 1);
                    var o = e(".quick-view .product-title a").html(),
                        n = e(".quick-view .quickview-featured-image img").attr("src");
                    t.doAjaxAddToCart(i, a, o, n), t.closeQuickViewPopup(), t.closeQuickViewCenterPopup();
                });
        },
        updateDropdownCart: function () {
            Shopify.getCart(function (i) {
                t.doUpdateDropdownCart(i);
            });
        },
        doUpdateDropdownCart: function (i) {
            if (
                (e("#cartCount").text(i.item_count),
                e("#cartCount2").text(i.item_count),
                e("#dropdown-cart .summary .price").html(Shopify.formatMoney(i.total_price, window.money_format)),
                e("#dropdown-cart .mini-products-list").html(""),
                i.item_count > 0)
            ) {
                for (var a = 0; a < i.items.length; a++) {
                    var o =
                        '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
                    (o = (o = (o = (o = (o = (o = o.replace(/\{ID\}/g, i.items[a].id)).replace(
                        /\{URL\}/g,
                        i.items[a].url
                    )).replace(/\{TITLE\}/g, t.translateText(i.items[a].title))).replace(
                        /\{QUANTITY\}/g,
                        i.items[a].quantity
                    )).replace(/\{IMAGE\}/g, Shopify.resizeImage(i.items[a].image, "small"))).replace(
                        /\{PRICE\}/g,
                        Shopify.formatMoney(i.items[a].price, window.money_format)
                    )),
                        e("#dropdown-cart .mini-products-list").append(o);
                }
                e("#dropdown-cart .btn-remove").click(function (i) {
                    i.preventDefault();
                    var a = e(this).parents(".item").attr("id");
                    (a = a.match(/\d+/g)),
                        Shopify.removeItem(a, function (i) {
                            t.doUpdateDropdownCart(i);
                        });
                }),
                    t.checkNeedToConvertCurrency() &&
                        Currency.convertAll(
                            window.shop_currency,
                            jQuery("#currencies").val(),
                            "#dropdown-cart span.money",
                            "money_format"
                        );
            }
            t.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function () {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function (a, o) {
            var n = Shopify.resizeImage(a.featured_image, "grande");
            if (
                (o
                    .find(".quickview-featured-image")
                    .append(
                        '<a href="' +
                            a.url +
                            '"><img src="' +
                            n +
                            '" title="' +
                            a.title +
                            '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' +
                            window.loading_url +
                            ') 50% 50% no-repeat;"></div></a>'
                    ),
                a.images.length > 1)
            ) {
                var r = o.find(".more-view-wrapper ul"),
                    s = 0;
                for (i in a.images)
                    if (s < a.images.length) {
                        var l =
                            '<li><a href="javascript:void(0)" data-image="' +
                            Shopify.resizeImage(a.images[i], "grande") +
                            '"><img src="' +
                            Shopify.resizeImage(a.images[i], "compact") +
                            '"  /></a></li>';
                        r.append(l), (s += 1);
                    }
                r.find("a").click(function () {
                    var i = o.find(".quickview-featured-image img"),
                        t = o.find(".quickview-featured-image div");
                    i.attr("src") != e(this).attr("data-image") &&
                        (i.attr("src", e(this).attr("data-image")),
                        t.show(),
                        i.load(function (i) {
                            t.hide(), e(this).unbind("load"), t.hide();
                        }));
                }),
                    r.hasClass("quickview-more-views-owlslider")
                        ? t.initQuickViewCarousel(r)
                        : t.initQuickViewVerticalMoreview(r);
            } else o.find(".quickview-more-views").remove(), o.find(".quickview-more-view-wrapper-jcarousel").remove();
        },
        initQuickViewCarousel: function (i) {
            i &&
                i
                    .owlCarousel({
                        navigation: !0,
                        items: 5,
                        itemsDesktop: [1199, 4],
                        itemsDesktopSmall: [979, 3],
                        itemsTablet: [768, 3],
                        itemsTabletSmall: [540, 3],
                        itemsMobile: [360, 3],
                    })
                    .css("visibility", "visible");
        },
        initQuickViewVerticalMoreview: function (i) {
            i &&
                (i.jcarousel({ vertical: !0 }),
                e(".product-img-box").addClass("has-jcarousel"),
                e(".more-view-wrapper").css("visibility", "visible"));
        },
        convertToSlug: function (i) {
            return i
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");
        },
        createQuickViewVariantsSwatch: function (i, t) {
            if (i.variants.length > 1) {
                for (var a = 0; a < i.variants.length; a++) {
                    var o = '<option value="' + (p = i.variants[a]).id + '">' + p.title + "</option>";
                    t.find("form.variants > select").append(o);
                }
                new Shopify.OptionSelectors("product-select-" + i.id, {
                    product: i,
                    onVariantSelected: selectCallbackQuickview,
                });
                var n = window.file_url.substring(0, window.file_url.lastIndexOf("?")),
                    r = window.asset_url.substring(0, window.asset_url.lastIndexOf("?")),
                    s = "";
                for (a = 0; a < i.options.length; a++) {
                    (s += '<div class="swatch clearfix" data-option-index="' + a + '">'),
                        (s += '<div class="header">' + i.options[a].name + "</div>");
                    var l = !1;
                    /Color|Colour/i.test(i.options[a].name) && (l = !0);
                    for (var c = new Array(), d = 0; d < i.variants.length; d++) {
                        var p,
                            u = (p = i.variants[d]).options[a],
                            h = this.convertToSlug(u),
                            f = "swatch-" + a + "-" + h;
                        c.indexOf(u) < 0 &&
                            ((s +=
                                '<div data-value="' +
                                u +
                                '" class="swatch-element ' +
                                (l ? "color" : "") +
                                h +
                                (p.available ? " available " : " soldout ") +
                                '">'),
                            l && (s += '<div class="tooltip">' + u + "</div>"),
                            (s +=
                                '<input id="' +
                                f +
                                '" type="radio" name="option-' +
                                a +
                                '" value="' +
                                u +
                                '" ' +
                                (0 == d ? " checked " : "") +
                                (p.available ? "" : " disabled") +
                                " />"),
                            (s += l
                                ? '<label for="' +
                                  f +
                                  '" style="background-color: ' +
                                  h +
                                  "; background-image: url(" +
                                  n +
                                  h +
                                  '.png)"><img class="crossed-out" src="' +
                                  r +
                                  'soldout.png" /></label>'
                                : '<label for="' +
                                  f +
                                  '">' +
                                  u +
                                  '<img class="crossed-out" src="' +
                                  r +
                                  'soldout.png" /></label>'),
                            (s += "</div>"),
                            p.available &&
                                e('.quick-view .swatch[data-option-index="' + a + '"] .' + h)
                                    .removeClass("soldout")
                                    .addClass("available")
                                    .find(":radio")
                                    .removeAttr("disabled"),
                            c.push(u));
                    }
                    s += "</div>";
                }
                t.find("form.variants > select").after(s),
                    t.find(".swatch :radio").change(function () {
                        var i = e(this).closest(".swatch").attr("data-option-index"),
                            t = e(this).val();
                        e(this).closest("form").find(".single-option-selector").eq(i).val(t).trigger("change");
                    }),
                    i.available && ((Shopify.optionsMap = {}), Shopify.linkOptionSelectors(i));
            } else {
                t.find("form.variants > select").remove();
                var m = '<input type="hidden" name="id" value="' + i.variants[0].id + '">';
                t.find("form.variants").append(m);
            }
        },
        createQuickViewVariants: function (i, t) {
            if (i.variants.length > 1) {
                for (var a = 0; a < i.variants.length; a++) {
                    var o = i.variants[a],
                        n = '<option value="' + o.id + '">' + o.title + "</option>";
                    t.find("form.variants > select").append(n);
                }
                if (
                    (new Shopify.OptionSelectors("product-select-" + i.id, {
                        product: i,
                        onVariantSelected: selectCallbackQuickview,
                    }),
                    1 == i.options.length)
                ) {
                    e(".selector-wrapper:eq(0)").prepend("<label>" + i.options[0].name + "</label>");
                    for (var r = i.variants, s = 0; s < r.length; s++) {
                        var l = r[s];
                        l.available ||
                            jQuery(".single-option-selector option")
                                .filter(function () {
                                    return jQuery(this).html() === l.title;
                                })
                                .remove();
                    }
                }
                e(".quick-view .single-option-selector").selectize(),
                    e(".quick-view .selectize-input input").attr("disabled", "disabled"),
                    t.find("form.variants .selector-wrapper label").each(function (t, a) {
                        e(this).html(i.options[t].name);
                    });
            } else {
                t.find("form.variants > select").remove();
                var c = '<input type="hidden" name="id" value="' + i.variants[0].id + '">';
                t.find("form.variants").append(c);
            }
        },
        closeQuickViewPopup: function () {
            e("html").removeClass("overflow-hidden"), e(".quick-view").fadeOut(500);
        },
        closeQuickViewCenterPopup: function () {
            e("html").removeClass("overflow-hidden"), e(".quick-view-center").fadeOut(500);
        },
        translateText: function (i) {
            if (!window.multi_lang || i.indexOf("|") < 0) return i;
            if (window.multi_lang) {
                var e = i.split("|");
                return translator.isLang2() ? e[1] : e[0];
            }
        },
        translateBlock: function (i) {
            window.multi_lang && translator.isLang2() && translator.doTranslate(i);
        },
    };
    e(".collection-sidebar") &&
        History.Adapter.bind(window, "statechange", function () {
            if ((History.getState(), !t.isSidebarAjaxClick)) {
                t.sidebarParams();
                var i = t.sidebarCreateUrl();
                t.sidebarGetContent(i), t.reActivateSidebar();
            }
            t.isSidebarAjaxClick = !1;
        }),
        window.use_color_swatch &&
            (e(".swatch :radio").change(function () {
                var i = e(this).closest(".swatch").attr("data-option-index"),
                    t = e(this).val();
                e(this).closest("form").find(".single-option-selector").eq(i).val(t).trigger("change");
            }),
            (Shopify.optionsMap = {}),
            (Shopify.updateOptionsInSelector = function (i) {
                switch (i) {
                    case 0:
                        var t = "root",
                            a = e(".single-option-selector:eq(0)");
                        break;
                    case 1:
                        (t = e(".single-option-selector:eq(0)").val()), (a = e(".single-option-selector:eq(1)"));
                        break;
                    case 2:
                        (t = e(".single-option-selector:eq(0)").val()),
                            (t += " / " + e(".single-option-selector:eq(1)").val()),
                            (a = e(".single-option-selector:eq(2)"));
                }
                var o = a.val();
                a.empty();
                var n = Shopify.optionsMap[t];
                if (n && n.length) {
                    for (var r = 0; r < n.length; r++) {
                        var s = n[r],
                            l = e("<option></option>").val(s).html(s);
                        a.append(l);
                    }
                    e('.swatch[data-option-index="' + i + '"] .swatch-element').each(function () {
                        -1 !== e.inArray(e(this).attr("data-value"), n)
                            ? e(this)
                                  .removeClass("soldout")
                                  .show()
                                  .find(":radio")
                                  .removeAttr("disabled", "disabled")
                                  .removeAttr("checked")
                            : e(this)
                                  .addClass("soldout")
                                  .show()
                                  .find(":radio")
                                  .removeAttr("checked")
                                  .attr("disabled", "disabled");
                    }),
                        -1 !== e.inArray(o, n) && a.val(o),
                        a.trigger("change");
                }
            }),
            (Shopify.linkOptionSelectors = function (i) {
                for (var t = 0; t < i.variants.length; t++) {
                    var a = i.variants[t];
                    if (a.available) {
                        if (
                            ((Shopify.optionsMap.root = Shopify.optionsMap.root || []),
                            Shopify.optionsMap.root.push(a.option1),
                            (Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root)),
                            i.options.length > 1)
                        ) {
                            var o = a.option1;
                            (Shopify.optionsMap[o] = Shopify.optionsMap[o] || []),
                                Shopify.optionsMap[o].push(a.option2),
                                (Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o]));
                        }
                        3 === i.options.length &&
                            ((o = a.option1 + " / " + a.option2),
                            (Shopify.optionsMap[o] = Shopify.optionsMap[o] || []),
                            Shopify.optionsMap[o].push(a.option3),
                            (Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])));
                    }
                }
                Shopify.updateOptionsInSelector(0),
                    i.options.length > 1 && Shopify.updateOptionsInSelector(1),
                    3 === i.options.length && Shopify.updateOptionsInSelector(2),
                    e(".single-option-selector:eq(0)").change(function () {
                        return (
                            Shopify.updateOptionsInSelector(1),
                            3 === i.options.length && Shopify.updateOptionsInSelector(2),
                            !0
                        );
                    }),
                    e(".single-option-selector:eq(1)").change(function () {
                        return 3 === i.options.length && Shopify.updateOptionsInSelector(2), !0;
                    });
            })),
        e(document).ready(function () {
            t.init();
        }),
        e(window).resize(function () {
            t.initMobileMenu(), t.initResizeImage(), t.initResizeModalView();
        }),
        e(window).scroll(function () {
            e(this).scrollTop() > 200 ? e("#back-top").fadeIn() : e("#back-top").fadeOut();
        }),
        e(".header-mobile").is(":visible") ||
            e(document).on("click touchstart", function (i) {
                var a = e(".quick-view"),
                    o = e(".quick-view-center"),
                    n = e("#dropdown-cart"),
                    r = e("#cartToggle"),
                    s = e("#email-modal .modal-window"),
                    l = e(".nav-search");
                a.is(i.target) ||
                    0 !== a.has(i.target).length ||
                    o.is(i.target) ||
                    0 !== o.has(i.target).length ||
                    n.is(i.target) ||
                    0 !== n.has(i.target).length ||
                    r.is(i.target) ||
                    0 !== r.has(i.target).length ||
                    s.is(i.target) ||
                    0 !== s.has(i.target).length ||
                    l.is(i.target) ||
                    0 !== l.has(i.target).length ||
                    (t.closeQuickViewPopup(),
                    t.closeQuickViewCenterPopup(),
                    t.closeDropdownCart(),
                    t.closeEmailModalWindow(),
                    t.closeDropdownSearch());
            }),
        e(document).keyup(function (i) {
            27 == i.keyCode &&
                (t.closeQuickViewPopup(),
                t.closeQuickViewCenterPopup(),
                t.closeDropdownCart(),
                t.closeDropdownSearch(),
                clearTimeout(t.ellaTimeout),
                e(".modal").is(":visible") && e(".modal").fadeOut(500));
        });
})(jQuery);
